import { envHelper } from '@/helpers/envHelper'
import { FileHelper, TokenData } from '../../fileHelper'
import { get } from '../common'

type ApiResponse<T> = ApiTypes.ApiResponse<T>

const COS_PREFIX = envHelper.isProd ? '/business/homesite/assets' : '/byy_test'

class Cos extends FileHelper {
  constructor(public prefix: string) {
    super(prefix)
  }

  async getUploadToken(): Promise<TokenData | null> {
    try {
      const res = await get<ApiResponse<TokenData>>('/admin/cos/sts_put_token')
      return res.data
    } catch (error) {
      return null
    }
  }

  async getDownloadToken(key: string): Promise<TokenData | null> {
    try {
      const res = await get<ApiResponse<TokenData>>('/admin/cos/sts_get_token', { key })
      return res.data
    } catch (error) {
      return null
    }
  }
}

const cos = new Cos(COS_PREFIX)

export default cos
